



















import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CanBeSizedMixin from '../../mixins/CanBeSizedMixin.vue';
import ScrollableMixin from '../../mixins/ScrollableMixin.vue';
import { ShopInfoModel } from '@/models/ShopDetails';

@Component({})
export default class ShopLiteDetails extends mixins(CanBeSizedMixin, ScrollableMixin) {
  /* tslint:disable */
  @Prop() private shopInfos!: ShopInfoModel[];
  /* tslint:enable */

  private getShopAddress(shopInfo: ShopInfoModel) {
    return `${shopInfo.postalCode}&nbsp;${shopInfo.city}${this.getDistanceString(shopInfo)}`;
  }
  private getDistanceString(info: ShopInfoModel) {
    if (info.distance < 5) {
      return '';
    }
    return `&nbsp;(${info.distance}&nbsp;km)`;
  }
  private getShopUrl(shop: ShopInfoModel) {
    return `https://www.digitalkamera.de/Haendler/${shop.urlFriendlyName}/${shop.id}`;
  }
}
